export enum RevenueEnum {
  MULTAS_ARCE = 7706,
  TAXAS_ARCE = 6254,
  TAXA_PL = 6211,
  TAXA_OUTORGA = 8494
}

export const RevenueEnumAll = [
  { key: 'Multas ARCE', value: RevenueEnum.MULTAS_ARCE },
  { key: 'Taxas ARCE', value: RevenueEnum.TAXAS_ARCE },
  { key: 'Segunda Via Passe Livre', value: RevenueEnum.TAXA_PL },
  { key: 'Taxa de Outorga de Serviços de Transporte Rodoviário', value: RevenueEnum.TAXA_OUTORGA }
]
